// extracted by mini-css-extract-plugin
export default {"imageWrapper":"rP-z","hovered":"sP-z","hoverImage":"tP-z","mainImage":"uP-z","imageNoBackground":"vP-z","fullSizeImage":"wP-z"};